import React  from 'react';
import FormField from "./FormField";
import { Validators } from "Utils/Constants";

/**
 *
 * @param {EmailField.defaultProps} props
 * @returns
 */
const EmailField = (props) => {
  return (
    <FormField {...props} />
  );
}

EmailField.defaultProps = {
  ...FormField.defaultProps,
  validators: [Validators.EMAIL],
  placeholder: 'jane@doe.com',
  type: 'email'
};

export default EmailField;